import { useLang } from '../../../../../../../../hooks/use-lang';
import { useAdminsStore } from '../../../../../../../../store/use-admins-store';

export const useCompanyAdminsCreateModalStep2 = () => {
  const { t } = useLang();

  const { handleUpdateAdmin, admin } = useAdminsStore();

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    const name = e.target.name;
    handleUpdateAdmin({ ...admin, [name]: val });
  };

  return { t, admin, handleChangeInput };
};
